export interface NodeActionProps {
  icon: string;
  text?: string;
  tooltip?: string;
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
}

const NodeAction = (props: NodeActionProps) => {
  return (
    <button
      onClick={props.onClick}
      className="btn-node-action"
      style={{ color: props.color ?? '' }}
      {...(props.disabled ? { disabled: true } : {})}>
      <i className={props.icon}></i>
      <span className="action-tooltip">{props.text}</span>
    </button>
  );
}

export default NodeAction;
